import EnterRecoveryFreespins from "slotworks/state-machine/standard/states/enter-recovery-freespins";
import DSComponents from "components/components";
import soundManager from "slotworks/sound/sound-manager";
import { SoundEvent } from "slotworks/sound/sound-events";
import gameState from "slotworks/model/game-state";
import EnterFreespinsTransition from "transitions/enter-freespins-transitions";
import Layers from "slotworks/graphics/layers/layers";
import deviceInfo from "slotworks/utils/device-info";

export default class ICEnterRecoveryFreespins extends EnterRecoveryFreespins {

    public onEnter() {
        soundManager.event(SoundEvent.start_freespin);
        // EnterFreespinsTransition.playTorchAnimation();
        Layers.Custom.get("Torches").setScene("freespins").then(EnterFreespinsTransition.startTorch);
        deviceInfo.onLayoutChange.add(EnterFreespinsTransition.startTorch);
        DSComponents.coinPots.bankCoinsOnFreespin();
        gameState.getCurrentGame().inFreespinsGame = true;
        super.onEnter();
    }
}
